module.exports = __webpack_public_path__ + "img/Honda.da2fba3d.jpg";